// extracted by mini-css-extract-plugin
export var checkbox = "_7q-0";
export var circle = "_7q-3";
export var horizontalContainer = "_7q-7";
export var sm = "_7q-5";
export var switch0 = "_7q-2";
export var switchDisabled = "_7q-8";
export var switchEnabled = "_7q-1";
export var textSwitchContainer = "_7q-9";
export var textSwitchOption = "_7q-a";
export var textSwitchOptionSelected = "_7q-b";
export var verticalContainer = "_7q-6";
export var xs = "_7q-4";